"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TokenSource = void 0;
var _asyncMutex = require("async-mutex");
var _ = require(".");
var _util = require("../util");
class TokenSource {
  mutex = new _asyncMutex.Mutex();
  constructor(tokenRequester, getTokenRequestConfig, store, logger = _util.noopLogger, expiryDelta = 10) {
    this.tokenRequester = tokenRequester;
    this.getTokenRequestConfig = getTokenRequestConfig;
    this.store = store;
    this.logger = logger;
    this.expiryDelta = expiryDelta;
  }
  async getToken() {
    try {
      const token = await this._getToken();
      return token;
    } catch (e) {
      this.logger.debug({
        caller: "TokenSource.getToken",
        message: `trying get get token after clear cache because an error occurred at 1st attempt: ${e}`
      });
      this.store.clear();
      return this._getToken();
    }
  }
  async _getToken() {
    const token = await this.store.get();
    if (token && !this.isExpired(token)) {
      this.logger.debug({
        caller: "TokenSource._getToken",
        message: "cached token is found in store"
      });
      return token;
    }
    this.logger.debug({
      caller: "TokenSource._getToken",
      message: "token is not found or expired."
    });
    return this.mutex.runExclusive(async () => {
      this.logger.debug({
        caller: "TokenSource._getToken",
        message: "checking token again after taking lock"
      });
      const cache = await this.store.get();
      if (cache && !this.isExpired(cache)) {
        return cache;
      }
      this.logger.debug({
        caller: "TokenSource._getToken",
        message: "retrieving new token"
      });
      const token = await this.retrieveToken();
      await this.store.set(token);
      this.logger.debug({
        caller: "TokenSource._getToken",
        message: "cache token to store"
      });
      return token;
    });
  }
  async retrieveToken() {
    const body = await this.getTokenRequestBody();
    this.logger.debug({
      caller: "TokenSource.retrieveToken",
      message: `TokenRequest.grant_type: ${body.grant_type}`
    });
    const res = await this.tokenRequester.request(body);
    return {
      accessToken: res.access_token,
      expiry: this.unixTimeNow() + res.expires_in,
      refreshToken: res.refresh_token,
      tokenType: res.token_type
    };
  }
  async getTokenRequestBody() {
    const token = await this.store.get();
    if (!(token !== null && token !== void 0 && token.refreshToken)) {
      return this.getTokenRequestConfig();
    }
    return _.TokenRequestBuilder.refreshToken({
      refresh_token: token.refreshToken
    });
  }
  isExpired(token) {
    return token.expiry - this.expiryDelta <= this.unixTimeNow();
  }
  unixTimeNow = () => {
    const date = new Date();
    const unixMilliSeconds = date.getTime();
    return Math.floor(unixMilliSeconds / 1000);
  };
}
exports.TokenSource = TokenSource;
//# sourceMappingURL=TokenSource.js.map